export default "__VITE_ASSET__CbY68L0y__"